import React, { Fragment, Component } from 'react';
import Lightbox from 'react-images';
import FsLightbox from 'fslightbox-react';


class LightboxImages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            toggler: true,
            updated: true,
            slide: 1,
            source: '',
            sourceIndex: 0,
        };

        this.toggleLightbox = this.toggleLightbox.bind(this);
    }

    toggleLightbox(itemIndex) {
        this.setState({
            toggler: !this.state.toggler,
            sourceIndex: itemIndex
        });
}


    render() {
        return (
            !this.props.items || this.props.items.length < 5 ?
                <Fragment>
                    <div className="product-images">
                        <div className="small-12 columns product-detail__main-image no-padding">
                            <figure className="product-detail__image-container">
                                <a data-src={this.props.items[0].src} itemProp="url" onClick={() => this.toggleLightbox(0)} className="product-image">
                                    <img className="product-detail__image--main" itemProp="image" src={this.props.thumbnails[0].src} alt={this.props.thumbnails[0].alt} />
                                </a>
                            </figure>
                        </div>
                        <div className="small-12 columns no-padding">
                            <div className="product-detail__thumbnails">
                                        
                                {this.props.items.map((item, index) => (
                                    index > 0 &&
                                    <a data-src={item.src} itemProp="url" onClick={() => this.toggleLightbox(index)} key={index} className="product-detail__image-container">
                                        {this.props.thumbnails[index].src ?
                                            <img className={`product-detail__image--alter ${this.props.thumbnails[index].type}-thumbnail`} itemProp="image" src={this.props.thumbnails[index].src} alt={this.props.thumbnails[index].alt} />
                                            : <span className="missing-image-box" />}
                                        {this.props.thumbnails[index].type === "video" &&
                                            <img className="video-icon" />
                                        }

                                    </a>
                                ))}
                                        
                            </div>
                        </div>
                    </div>

                    <FsLightbox
                        toggler={this.state.toggler}
                        sourceIndex={this.state.sourceIndex}
                        loadOnlyCurrentSource={true}
                        sources={this.props.items}
                        thumbs={this.props.thumbnails}
                    />
                </Fragment>
                : <Fragment>
                <div className="product-images">
                    <div className="small-12 columns product-detail__main-image no-padding">
                        <figure className="product-detail__image-container">
                            <a data-src={this.props.items[0].src} itemProp="url" onClick={() => this.toggleLightbox(0)} className="product-image">
                                    <img className="product-detail__image--main" itemProp="image" src={this.props.thumbnails[0].src} alt={this.props.thumbnails[0].alt} />
                            </a>
                        </figure>
                    </div>                    
                    <div className="small-12 columns no-padding">
                        <div className="glider-container">
                            <div className="product-detail__glider-thumbnails glide--ltr glide--carousel glide--swipeable">
                                <div className="glide__track" data-glide-el="track">
                                    <div className="glide__slides">
                                        {this.props.items.map((item, index) => (
                                            index > 0 &&
                                            <div className="glide__slide" key={index}>
                                                <a data-src={item.src} itemProp="url" onClick={() => this.toggleLightbox(index)} key={index} className="product-detail__image-container">
                                                    {this.props.thumbnails[index].src ?
                                                        <img className={`product-detail__image--alter ${this.props.thumbnails[index].type}-thumbnail`} itemProp="image" src={this.props.thumbnails[index].src} alt={this.props.thumbnails[index].alt} />
                                                        : <span className="missing-image-box" />}
                                                    {this.props.thumbnails[index].type === "video" &&
                                                        <img className="video-icon" />
                                                    }

                                                </a>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                                <div className="glide">
                                    <div className="glide__arrows" data-glide-el="controls">
                                        <span className="glide__arrow glide__arrow--prev" data-glide-dir="<"></span>
                                        <span className="glide__arrow glide__arrow--next" data-glide-dir=">"></span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>                    
                </div>

                <FsLightbox
                    toggler={this.state.toggler}
                    sourceIndex={this.state.sourceIndex}
                    loadOnlyCurrentSource={true}
                    sources={this.props.items}
                    thumbs={this.props.thumbnails}
                />
            </Fragment>
        );
    }
}

export default LightboxImages;